<template>
  <b-container>
    <FeedListFilters
      class="mb-3 small"
      :hashtag="hashtag"
      @remove-hashtag-filter="removeHashtagFilter"
    />
    <b-row cols="4" no-gutters>
      <b-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        v-for="feed in feeds"
        :key="feed.id"
      >
        <FeedCard
          :feed="feed"
          class="mr-5 mb-5"
          @open="openFeed(feed)"
          @click-tag="filterFeedByTag"
        />
      </b-col>
      <b-col class="m-auto text-center pt-4 show-more-less" cols="12">
        <ShowMore
          v-if="has_more"
          @more="loadHomeFeeds(page + 1)"
          :loading="loading"
        />
        <ShowLess @less="showLessFeeds()" v-if="page > 1 && feeds.length > 8" />
      </b-col>
    </b-row>

    <play-video-modal
      v-if="video_src && video_poster"
      :src="video_src"
      :poster="video_poster"
      :modal="true"
    />
  </b-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import PlayVideoModal from '@/views/components/PlayVideoModal'
import FeedCard from '@/views/components/Feed/FeedCard'
import FeedListFilters from '@/views/components/Feed/FeedListFilters'
import { scrollToTop } from '@/utils/scroll'
import ShowMore from '@/views/components/ShowMore'
import ShowLess from '@/views/components/ShowLess.vue'

export default {
  name: 'FeedsList',
  props: {
    list: { type: String, required: true },
  },
  components: {
    ShowLess,
    ShowMore,
    FeedListFilters,
    FeedCard,
    PlayVideoModal,
  },

  data() {
    return {
      limit: 8,
      video_src: null,
      video_poster: null,
      hashtag: null,
    }
  },

  mounted() {
    this.refreshFeed()
  },

  computed: {
    ...mapState({
      feeds: (state) => state.feed.list,
      has_more: (state) => state.feed.has_more,
      loading: (state) => state.feed.loading,
      storePage: (state) => state.feed.page,
    }),

    page: {
      get() {
        return this.storePage
      },
      set(value) {
        this.setPage(value)
      },
    },

    params() {
      return {
        limit: this.limit,
        page: this.page,
        filter: this.list,
        hashtag: this.hashtag,
      }
    },
  },

  methods: {
    ...mapActions({
      getHomeFeeds: 'feed/getHomeFeeds',
      showLessFeeds: 'feed/showLessFeeds',
    }),
    ...mapMutations({
      clearHomeFeeds: 'feed/clearList',
      setPage: 'feed/setPage',
    }),

    openFeed(feed) {
      this.playVideo(feed)
    },

    async loadHomeFeeds(page = 1) {
      this.page = page
      await this.getHomeFeeds(this.params)
    },

    async playVideo(feed) {
      if (feed.vello_export) {
        this.video_src = feed.vello_export.file_url
      } else {
        this.video_src = feed.video_url
      }

      this.video_poster = feed.thumbnails.orig
      this.$bvModal.show(`playVideoFrame`)
    },

    async refreshFeed() {
      await this.clearHomeFeeds()
      await this.loadHomeFeeds()
    },

    async filterFeedByTag(tag) {
      this.hashtag = tag
      await this.refreshFeed()
      scrollToTop()
    },

    async removeHashtagFilter() {
      this.hashtag = null
      await this.refreshFeed()
    },
  },

  async destroyed() {
    await this.clearHomeFeeds()
  },
}
</script>
